// src/utils/dateUtils.js

const formatDateTime = (dateTimeString) => {
  if (!dateTimeString) return { date: "", time: "" };

  const date = new Date(dateTimeString);
  const formattedDate = date.toLocaleDateString("en-GB"); // Formats to 'dd/mm/yyyy'
  const formattedTime = date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return {
    date: formattedDate,
    time: formattedTime,
  };
};

const convertUTCToLocalTime = (utcTime) => {
  const currentDate = new Date();
  const [hours, minutes] = utcTime.split(":");
  currentDate.setUTCHours(parseInt(hours, 10));
  currentDate.setUTCMinutes(parseInt(minutes.replace("Z", ""), 10));

  return currentDate.toLocaleTimeString([], {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};
const getFormattedLocalTime = (utcDateString) => {
  const localDate = new Date(utcDateString);
  localDate.setHours(localDate.getHours());

  return localDate.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};
const getFormattedLocalTimeWithMinusHour = (utcDateString) => {
  const localDate = new Date(utcDateString);
  localDate.setHours(localDate.getHours() - 1);

  return localDate.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};
const getFormattedArrivalLocalTime = (utcDateString) => {
  const localDate = new Date(utcDateString);
  localDate.setHours(localDate.getHours());

  return localDate.toLocaleTimeString(undefined, {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });
};
const getCurrentTimestamp = () => {
  const now = new Date();
  const day = String(now.getDate()).padStart(2, "0");
  const month = String(now.getMonth() + 1).padStart(2, "0");
  const year = now.getFullYear();
  const hours = String(now.getHours()).padStart(2, "0");
  const minutes = String(now.getMinutes()).padStart(2, "0");
  const seconds = String(now.getSeconds()).padStart(2, "0");

  return `${day}/${month}/${year}_${hours}:${minutes}:${seconds}`;
};
function getTimeDurationFor(time1, time2) {
  const [hours1, minutes1] = time1.split(":").map(Number);
  const [hours2, minutes2] = time2.split(":").map(Number);

  const totalMinutes1 = hours1 * 60 + minutes1;
  const totalMinutes2 = hours2 * 60 + minutes2;

  const differenceInMinutes = Math.abs(totalMinutes1 - totalMinutes2);

  const hours = String(Math.floor(differenceInMinutes / 60)).padStart(2, "0");
  const minutes = String(differenceInMinutes % 60).padStart(2, "0");

  return `${hours}:${minutes}`;
}

const customDateFormat = (isoString) => {
  const date = new Date(isoString);

  // Check if the date is valid
  if (isNaN(date.getTime())) {
    return '';
  }

  const day = String(date.getDate()).padStart(2, "0");
  const month = String(date.getMonth() + 1).padStart(2, "0"); // Months are 0-based
  const year = date.getFullYear();

  const hours = String(date.getHours()).padStart(2, "0");
  const minutes = String(date.getMinutes()).padStart(2, "0");
  const seconds = String(date.getSeconds()).padStart(2, "0");

  return `${day}/${month}/${year}_${hours}:${minutes}:${seconds}`;
};

const formatToCustomDate = (dateString) => {
  // dateString is in 'dd/mm/yyyy'
  const [day, month, year] = dateString.split("/");
  // Use local date object
  const date = new Date(Number(year), Number(month) - 1, Number(day));
  const options = { day: "2-digit", month: "short", year: "numeric" };
  // This will output '19 May 2025'
  const formattedDate = date.toLocaleDateString("en-GB", options);
  // Insert a comma after the month to match test expectation: '19 May, 2025'
  return formattedDate.replace(/(\d{2}) (\w{3}) (\d{4})/, "$1 $2, $3");
};

const formatDateTimeForUI = (dateTimeString) => {
  if (!dateTimeString) return "";

  const date = new Date(dateTimeString);

  const datePart = date.toLocaleDateString("en-GB", {
    day: "2-digit",
    month: "short",
    year: "numeric",
  });

  const timePart = date.toLocaleTimeString("en-GB", {
    hour: "2-digit",
    minute: "2-digit",
    hour12: false,
  });

  return `${datePart}, ${timePart}`;
};

const getTimezoneString = () => {
  const offset = new Date().getTimezoneOffset();
  const absOffset = Math.abs(offset);
  const hours = Math.floor(absOffset / 60);
  const minutes = absOffset % 60;
  const sign = offset > 0 ? "-" : "+";
  return `GMT ${sign}${hours.toString().padStart(2, "0")}:${minutes
    .toString()
    .padStart(2, "0")}`;
};

export {
  formatDateTime,
  convertUTCToLocalTime,
  getFormattedLocalTime,
  getFormattedArrivalLocalTime,
  getCurrentTimestamp,
  getTimeDurationFor,
  customDateFormat,
  formatToCustomDate,
  formatDateTimeForUI,
  getTimezoneString,
  getFormattedLocalTimeWithMinusHour,
};
